import React, { ReactElement } from 'react';

import Item from '~/Components/Item/Item';
import { ICategories, Item as IItem } from '~/interfaces';

import styles from './VirtualScroller.scss';

const ITEM_WIDTH = 205; // from Item.scss
const ITEM_HEIGHT = 120; // from Item.scss
const MIN_COLUMN_GAP = 20;
const ROW_GAP = 40;
const BUFFER_ROWS = 2;

export const ROW_HEIGHT = ITEM_HEIGHT + ROW_GAP;

interface VirtualScrollerProps {
    items: IItem[];
    category: ICategories;
    containerWidth: number;
    containerHeight: number;
    firstVisibleRow: number;
}

const VirtualScroller = ({ items, category, containerWidth, containerHeight, firstVisibleRow }: VirtualScrollerProps): ReactElement => {
    const columns = Math.max(1, Math.floor((containerWidth + MIN_COLUMN_GAP) / (ITEM_WIDTH + MIN_COLUMN_GAP)));

    const columnGap = columns > 1 ? (containerWidth - columns * ITEM_WIDTH) / (columns - 1) : 0;

    const columnWidth = ITEM_WIDTH + columnGap;

    const totalRows = Math.ceil(items.length / columns);
    const visibleRows = Math.ceil(containerHeight / ROW_HEIGHT);

    const startRow = Math.max(0, firstVisibleRow - BUFFER_ROWS);
    const endRow = Math.min(totalRows, firstVisibleRow + visibleRows + BUFFER_ROWS);

    const startIndex = startRow * columns;
    const endIndex = Math.min(items.length, endRow * columns);
    const visibleItems = items.slice(startIndex, endIndex);

    const totalHeight = totalRows * ITEM_HEIGHT + Math.max(0, totalRows - 1) * ROW_GAP;

    return (
        <div
            className={styles.scrollerWrapper}
            style={{
                height: totalHeight,
            }}
        >
            {visibleItems.map((item, localIndex) => {
                const index = startIndex + localIndex;
                const row = Math.floor(index / columns);
                const column = index % columns;
                const isExterior = item.tags.includes('Exterior');

                // @ts-ignore
                const uniqId = isExterior && item.vehicles?.[0]?.vehicle.id ? `${item.id}_${item.vehicles[0].vehicle.id}` : item.id;

                return (
                    <div
                        key={uniqId}
                        className={styles.itemWrapper}
                        style={{
                            width: ITEM_WIDTH,
                            height: ITEM_HEIGHT,
                            left: column * columnWidth,
                            top: row * ROW_HEIGHT,
                        }}
                    >
                        <Item category={category} item={item} />
                    </div>
                );
            })}
        </div>
    );
};

export default VirtualScroller;
